import { Dialog } from '@headlessui/react'
import {
  CheckCircleIcon,
  ExclamationTriangleIcon,
  InformationCircleIcon,
  XCircleIcon,
} from '@heroicons/react/24/outline'

const variants = {
  success: {
    icon: CheckCircleIcon,
    iconClasses: 'text-green-500',
    bgClasses: 'bg-green-50',
    titleDefault: 'Success',
  },
  error: {
    icon: XCircleIcon,
    iconClasses: 'text-red-500',
    bgClasses: 'bg-red-50',
    titleDefault: 'Something went wrong',
  },
  warning: {
    icon: ExclamationTriangleIcon,
    iconClasses: 'text-yellow-500',
    bgClasses: 'bg-yellow-50',
    titleDefault: 'Warning',
  },
  info: {
    icon: InformationCircleIcon,
    iconClasses: 'text-blue-500',
    bgClasses: 'bg-blue-50',
    titleDefault: 'Notice',
  },
}

export default function AlertModal({
  open,
  onClose,
  title,
  message,
  type = 'info',
  actionLabel = 'Close',
}) {
  const variant = variants[type] || variants.info
  const Icon = variant.icon

  return (
    <Dialog open={open} onClose={onClose} className="relative z-50">
      <div className="fixed inset-0 bg-black/20 backdrop-blur-sm" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="w-full max-w-md rounded-2xl bg-white shadow-xl">
          <div className={`flex items-start space-x-4 rounded-t-2xl px-6 py-5 ${variant.bgClasses}`}>
            <div className="flex-shrink-0">
              <Icon className={`h-8 w-8 ${variant.iconClasses}`} />
            </div>
            <div>
              <Dialog.Title className="text-lg font-semibold text-gray-900">
                {title || variant.titleDefault}
              </Dialog.Title>
              {message && (
                <Dialog.Description className="mt-2 text-sm text-gray-600">
                  {message}
                </Dialog.Description>
              )}
            </div>
          </div>
          <div className="px-6 py-4 bg-gray-50 rounded-b-2xl flex justify-end">
            <button
              type="button"
              onClick={onClose}
              className="inline-flex justify-center rounded-md bg-primary-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-primary-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2"
            >
              {actionLabel}
            </button>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  )
}
